export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGOUT = 'USER_LOGOUT'

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL'

export const USER_ADD_REQUEST = 'USER_ADD_REQUEST'
export const USER_ADD_SUCCESS = 'USER_ADD_SUCCESS'
export const USER_ADD_FAIL = 'USER_ADD_FAIL'

export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST'
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS'
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL'

export const ALL_USER_DETAILS_REQUEST = 'ALL_USER_DETAILS_REQUEST'
export const ALL_USER_DETAILS_SUCCESS = 'ALL_USER_DETAILS_SUCCESS'
export const ALL_USER_DETAILS_FAIL = 'ALL_USER_DETAILS_FAIL'

export const USER_UPDATE_PROFILE_REQUEST = 'USER_UPDATE_PROFILE_REQUEST'
export const USER_UPDATE_PROFILE_SUCCESS = 'USER_UPDATE_PROFILE_SUCCESS'
export const USER_UPDATE_PROFILE_FAIL = 'USER_UPDATE_PROFILE_FAIL'
export const USER_UPDATE_PROFILE_RESET = 'USER_UPDATE_PROFILE_RESET'

export const USER_CHANGE_PASS_FAIL = 'USER_CHANGE_PASS_FAIL'
export const USER_CHANGE_PASS_REQUEST = 'USER_CHANGE_PASS_REQUEST'
export const USER_CHANGE_PASS_SUCCESS = 'USER_CHANGE_PASS_SUCCESS'

// Admin constants
export const ADMIN_USERS_REQUEST = 'ADMIN_USERS_REQUEST'
export const ADMIN_USERS_SUCCESS = 'ADMIN_USERS_SUCCESS'
export const ADMIN_USERS_FAIL = 'ADMIN_USERS_FAIL'

export const ADMIN_USER_UPDATE_REQUEST = 'ADMIN_USER_UPDATE_REQUEST'
export const ADMIN_USER_UPDATE_SUCCESS = 'ADMIN_USER_UPDATE_SUCCESS'
export const ADMIN_USER_UPDATE_FAIL = 'ADMIN_USER_UPDATE_FAIL'

export const ADMIN_USER_DELETE_REQUEST = 'ADMIN_USER_DELETE_REQUEST'
export const ADMIN_USER_DELETE_SUCCESS = 'ADMIN_USER_DELETE_SUCCESS'
export const ADMIN_USER_DELETE_FAIL = 'ADMIN_USER_DELETE_FAIL'

export const ADMIN_LABS_REQUEST = 'ADMIN_LABS_REQUEST'
export const ADMIN_LABS_SUCCESS = 'ADMIN_LABS_SUCCESS'
export const ADMIN_LABS_FAIL = 'ADMIN_LABS_FAIL'

export const ADMIN_LAB_CREATE_REQUEST = 'ADMIN_LAB_CREATE_REQUEST'
export const ADMIN_LAB_CREATE_SUCCESS = 'ADMIN_LAB_CREATE_SUCCESS'
export const ADMIN_LAB_CREATE_FAIL = 'ADMIN_LAB_CREATE_FAIL'

export const ADMIN_LAB_UPDATE_REQUEST = 'ADMIN_LAB_UPDATE_REQUEST'
export const ADMIN_LAB_UPDATE_SUCCESS = 'ADMIN_LAB_UPDATE_SUCCESS'
export const ADMIN_LAB_UPDATE_FAIL = 'ADMIN_LAB_UPDATE_FAIL'

export const ADMIN_LAB_DELETE_REQUEST = 'ADMIN_LAB_DELETE_REQUEST'
export const ADMIN_LAB_DELETE_SUCCESS = 'ADMIN_LAB_DELETE_SUCCESS'
export const ADMIN_LAB_DELETE_FAIL = 'ADMIN_LAB_DELETE_FAIL'